(() => {
  const label = document.currentScript.dataset.soldOutLabel;
  const content = document.getElementById('content');
  if (!content || !label) return;

  const selector =
    '.snize-search-results .snize-product-out-of-stock .snize-view-product-button';
  let pending = false;

  function updateLabels() {
    pending = false;
    content.querySelectorAll(selector).forEach((button) => {
      if (button.textContent !== label) button.textContent = label;
    });
  }

  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(updateLabels);
  }).observe(content, {
    childList: true,
    subtree: true,
    characterData: true
  });

  updateLabels();
})();